export enum CheckoutPaymentPlanType {
	Cash = 'cash',
	Card = 'card',
	Invalid = 'invalid',
}

export const CheckoutAsyncActionType = {
	AvailabilitySuccess: '[Availability] Find Success',
	AvailabilityFailure: '[Availability] Failed',
	BusinessDaySuccess: '[Store] Check Business Day Success',
	BusinessDayFailure: '[Store] Check Business Day Failure',
} as const;
